// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"About_pageContent__1Bfc2","title":"About_title__2gf_3","subtitle":"About_subtitle__3qsVJ"};